import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";
import { PaymentEnum } from "../../enum/utilities/payment.enum";

export class GetDashboardAdminCommand extends IRequestCommand<
IGetDashboardCommandResponse,
  ErrorDetails,
  IGetDashboardAdminCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'admins/dashboard?';

  private params='';

  public override setParameters(parameters: IGetDashboardAdminCommandParameters) {
    this.params = (parameters.carrier) ? this.params + this.getAnd() + "carrier="+parameters.carrier : this.params;
    this.params = (parameters.country) ? this.params + this.getAnd() + "country="+parameters.country : this.params;
    this.params = (parameters.province) ? this.params + this.getAnd() + "province="+parameters.province : this.params;
    this.params = (parameters.year) ? this.params + this.getAnd() + "year="+parameters.year : this.params;
    this.params = (parameters.month) ? this.params + this.getAnd() + "month="+parameters.month : this.params;
    this.params = (parameters.dateFrom) ? this.params + this.getAnd() + "dateFrom="+parameters.dateFrom : this.params;
    this.params = (parameters.dateTo) ? this.params + this.getAnd() + "dateTo="+parameters.dateTo : this.params;
    this._commandUrl = this._commandUrl + this.params;
  }

  getAnd(){
    return (this.params==='')?'':'&';
  }

}

export interface IGetDashboardAdminCommandParameters extends ICommandParameters {
  carrier:string,
  country:string,
  province:string,
  year:string,
  month:number,
  dateFrom: string,
  dateTo: string
}

export interface IGetDashboardCommandResponse extends ICommandResponse {
    statistics:IGetDashboardAdminCommandResponse[];
    statisticsAdd: IGetDashboardAdminClientCommandResponse[];
    paymentMethods:IGetPaymentMethodDashboardCommandResponse[];
    numberOfCarriersAnnual:number;
    numberOfDriversAnnual:number;
    numberOfVehiculesAnnual:number;
}


export interface IGetPaymentMethodDashboardCommandResponse extends ICommandResponse {
    paymentMethod:PaymentEnum;
    amountPaymentMethod:number;
    amountDollarPaymentMethod:number;
}

export interface IGetDashboardAdminCommandResponse extends ICommandResponse {
    timeUnit:number,
    billing:number,
    dollarBilling:number,
    numberOfCarriers:number,
    numberOfCarriersActive:number,
    numberOfDrivers:number,
    numberOfDriversRegistered:number,
    numberOfDriversActive:number,
    numberOfVehicules:number,
    numberOfVehiculesRegistered:number,
    numberOfTravels:number,
    avgPriceTravel:number,
    dollarAvgPriceTravel:number,
    totalKms:number,
    currencyValue:number
}

export interface IGetDashboardAdminClientCommandResponse extends ICommandResponse {
  timeUnit: number,
  numberOfIndividualClientApp: number,
  numberOfIndividualClientCompany: number,
  numberOfCompanyClientWeb: number,
  numberOfCompanyClientCompany: number
}
